import type { IconProps } from '../types/IconProps.ts';
export const BriefcaseMedical: IconProps = {
    name: 'BriefcaseMedical',
    children: [
        `<rect width="20" height="14" x="2" y="6" rx="2" />`,
        `<path d="M8 6V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2M6 6v14M18 6v14M12 11v4M10 13h4" />`,
    ]
};